export default __webpack_public_path__ + "static/media/oreja.5c97faa9.jpg";